import { AutogenModelEquipmentGroup, AutogenRowEquipmentGroup } from "./autogen/AutogenModelEquipmentGroup";

export class ModelEquipmentGroup extends AutogenModelEquipmentGroup<RowEquipmentGroup> {
	constructor() {
		super(RowEquipmentGroup);
	}
}

export class RowEquipmentGroup extends AutogenRowEquipmentGroup {
}